/**
 * Master category IDs for system-generated tasks.
 * Values sourced from com.rev360.model.category.TaskMasterCategory.
 */
export const TASK_MASTER_CATEGORY = {
	RX: 1107,
	LETTER_DRAFT: 1110,
} as const;
